module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h5"
    }
  }, [_vm._v("List of Contributors")])]), _c('a', {
    attrs: {
      "id": "h5"
    }
  }, [_c('p', {
    staticClass: "common"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_vm._v("Professor Ian Beckett was formerly Professor of History at the University of Northampton. He is Chairman of the Army Records Society. His publications include "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Victorians at War")]), _vm._v(" (2003) and the forthcoming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolseley and Ashanti: The Asante War Journal and Correspondence of Major General Sir Garnet Wolseley, 1873–74")]), _vm._v(" for the Army Records Society.")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_vm._v("Dr Steven Corvi is Assistant Professor at the American Military University and is Northeast Chairman for Military History in the Popular Culture Association. His PhD was on Sir Horace Smith-Dorrien and he has contributed an article on the Royal Army Veterinary Corps to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JSAHR")]), _vm._v(". He has previously co-edited "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Haig’s Generals")]), _vm._v(" (2006) with Ian Beckett.")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_vm._v("Gerald H Herman is Assistant Professor of History at Northeastern University, Boston. His publications include "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Pivotal Conflict: Comprehensive Chronology of the First World War")]), _vm._v(" (1992) and a multi-media exploration of that war’s cultural impacts called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("World War I: the Destroying Fathers Confirmed")]), _vm._v(". He also co-edited "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Media, the Academy and the Law: Assessing the Truth from the Protocols of Zion to Holocaust Denial")]), _vm._v(" (2005).")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_vm._v("Professor John Laband is Professor of History at Wilfrid Laurier University, Waterloo, Ontario, and an Associate of the Laurier Centre for Military, Strategic and Disarmament Studies. His many publications include "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Transvaal Rebellion: The First Boer War")]), _vm._v(" (2005), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Chelmsford’s Zululand Campaign, 1878–79")]), _vm._v(" (1994), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rise and Fall of the Zulu Nation")]), _vm._v(" (1997) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kingdom in Crisis: The Zulu Response to the British Invasion of 1879")]), _vm._v(" (1992).")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_vm._v("Dr Stephen Manning is a visiting Professor of History at the University of Exeter, where he occasionally lectures on colonial warfare. He is the author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Evelyn Wood VC: Pillar of Empire")]), _vm._v(" (2007) and the forthcoming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Soldiers of the Queen")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_vm._v("Dr Stephen Miller is Assistant Professor of History at the University of Maine. His publications include "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Volunteers on the Veld: Britain’s Citizen Soldiers and the South African War")]), _vm._v(" (2007) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Methuen and the British Army")]), _vm._v(" (1999). He is the editor of the forthcoming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Soldiers and Settlers in South Africa, 1850-1918")]), _vm._v(" and is now working on discipline and punishment in the late Victorian army.")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_vm._v("Dr Keith Surridge teaches on various American university programmes in London. His publications include "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Managing the South African War, 1899–1902: Politicians versus Generals")]), _vm._v(" (1998) and (with Denis Judd) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Boer War")]), _vm._v(" (2002). He has also contributed articles on Kitchener and on the South African War to academic journals.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Professor André Wessels is Professor of History at the University of the Orange Free State, Bloemfontein, South Africa. His publications include two volumes for the Army Records Society, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Roberts and the War in South Africa, 1899–1902")]), _vm._v(" (2000) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Kitchener and the War in South Africa, 1899–1902")]), _vm._v(" (2006), as well as more than fifty articles in academic journals and several chapters in books.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-480d512a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_contributors.vue
// module id = 78
// module chunks = 0